import { render, staticRenderFns } from "./TabAttentions.vue?vue&type=template&id=1462f7bb&"
import script from "./TabAttentions.vue?vue&type=script&lang=ts&"
export * from "./TabAttentions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1462f7bb', component.options)
    } else {
      api.reload('1462f7bb', component.options)
    }
    module.hot.accept("./TabAttentions.vue?vue&type=template&id=1462f7bb&", function () {
      api.rerender('1462f7bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/TabsModals/TabAttentions.vue"
export default component.exports